var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5007_5375)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5007_5375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 16.1691C13.8907 16.1691 16.072 14.0787 16.072 11.5001C16.072 8.92144 13.8907 6.83105 11.2 6.83105C8.50927 6.83105 6.328 8.92144 6.328 11.5001C6.328 14.0787 8.50927 16.1691 11.2 16.1691Z",
    fill: "#6F82C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1359 11.5C15.1359 13.57 13.3599 15.272 11.1999 15.272C9.01592 15.272 7.26392 13.593 7.26392 11.5C7.26392 9.40703 9.01592 7.72803 11.1999 7.72803C13.3599 7.72803 15.1359 9.40703 15.1359 11.5Z",
    fill: "url(#paint0_linear_5007_5375)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1359 11.5C15.1359 13.57 13.3599 15.272 11.1999 15.272C9.01592 15.272 7.26392 13.593 7.26392 11.5C7.26392 9.40703 9.01592 7.72803 11.1999 7.72803C13.3599 7.72803 15.1359 9.40703 15.1359 11.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4319 9.63678L19.6239 9.13078C19.4559 8.57878 19.2399 8.04978 18.9519 7.56678L20.5599 5.28978C20.7039 5.05978 20.6799 4.78378 20.4879 4.57678L18.4719 2.64478C18.2799 2.46078 17.9679 2.43778 17.7519 2.59878L15.3759 4.13978C14.8479 3.86378 14.2719 3.63378 13.6959 3.47278L13.1679 0.781777C13.0959 0.528777 12.8799 0.344777 12.5919 0.321777H9.73591C9.47191 0.321777 9.23191 0.505777 9.15991 0.781777L8.63191 3.49578C8.07991 3.65678 7.52791 3.86378 7.02391 4.13978L4.67191 2.59878C4.43191 2.46078 4.14391 2.48378 3.92791 2.66778L1.91191 4.59978C1.71991 4.78378 1.69591 5.08278 1.83991 5.31278L3.47191 7.58978C3.20791 8.07278 2.96791 8.60178 2.79991 9.13078L-0.00808507 9.61377C-0.296085 9.65977 -0.512085 9.88977 -0.512085 10.1658V12.8798C-0.512085 13.1558 -0.320085 13.3628 -0.032085 13.4318L2.77591 13.9378C2.94391 14.4898 3.18391 15.0188 3.44791 15.5018L1.83991 17.7788C1.67191 18.0088 1.71991 18.3308 1.93591 18.5148L3.95191 20.4468C4.14391 20.6308 4.45591 20.6538 4.69591 20.5158L7.04791 18.9748C7.55191 19.2278 8.07991 19.4578 8.63191 19.6188L9.15991 22.3098C9.23191 22.5628 9.44791 22.7468 9.73591 22.7698H12.5919C12.8559 22.7698 13.0959 22.5858 13.1679 22.3098L13.6959 19.6188C14.2719 19.4578 14.8239 19.2508 15.3519 18.9748L17.7279 20.5158C17.9679 20.6538 18.2799 20.6308 18.4719 20.4468L20.4879 18.5148C20.6799 18.3308 20.7039 18.0318 20.5359 17.8018L18.9279 15.5248C19.2159 15.0188 19.4559 14.4898 19.6239 13.9378L22.4319 13.4318C22.6959 13.3628 22.8879 13.1328 22.9119 12.8798V10.1888C22.9119 9.91277 22.7199 9.68277 22.4319 9.63678ZM11.1999 16.2378C9.90391 16.2378 8.65591 15.7318 7.74391 14.8578C6.83191 13.9838 6.30391 12.7878 6.30391 11.5458C6.30391 10.3038 6.83191 9.10777 7.74391 8.23378C8.65591 7.35978 9.90391 6.85378 11.1999 6.85378C12.4959 6.85378 13.7439 7.35978 14.6559 8.23378C15.5679 9.10777 16.0959 10.3038 16.0959 11.5458C16.0959 12.7878 15.5919 13.9838 14.6559 14.8578C13.7439 15.7318 12.4959 16.2378 11.1999 16.2378Z",
    fill: "#6F82C4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5007_5375",
    x1: 7.26392,
    y1: 11.5,
    x2: 15.1359,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#008BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004B6B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5007_5375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5007_5375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white",
    transform: "translate(-0.800049)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsHeader);
export default __webpack_public_path__ + "static/media/settings_header.ea753fb9b875c74e22b1f5e13fa3e1dc.svg";
export { ForwardRef as ReactComponent };